import { render } from "./searchwidget.vue?vue&type=template&id=71b915d1&scoped=true"
import script from "./searchwidget.vue?vue&type=script&lang=js"
export * from "./searchwidget.vue?vue&type=script&lang=js"

import "./searchwidget.vue?vue&type=style&index=0&id=71b915d1&lang=css"
import "./searchwidget.vue?vue&type=style&index=1&id=71b915d1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71b915d1"]])

export default __exports__